// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1AqII","title":"ClientInsurance_title__2AUe-","itemText":"ClientInsurance_itemText__wDAkQ"};